<template>
    <c-pagination aria-label="..." v-if="source && source.last_page > 1" class="toolbox toolbox-pagination">
        <div class="toolbox-item toolbox-show show-count">
            <total-pagination>
                Mostrando de {{ source.from }} até {{ source.to }} de {{ source.total }} registros
            </total-pagination>
        </div>

        <ul class="pagination">
            <page-item :class="[ source.current_page == 1 ? 'disabled' : '']">
                <a class="arrow-link" href="#" @click="nextPrev($event, source.current_page-1)">
                    <i class="icon-angle-left"></i>
                </a>
            </page-item>
            <page-item v-for="(page, idx) in pages" :key="idx" track-by="$index" :class="[source.current_page == page ? 'active' : '',  'page-item' ]">
                <span v-if="page == '...'" >
                    {{ page }}
                </span>
                <a v-if="page != '...' && source.current_page != page" href="#" @click="navigate($event, page)">
                    {{ page }}    
                </a>
                <a v-if="page != '...' && source.current_page == page">
                    {{ page }}    
                </a>
            </page-item>
            <page-item :class="[ source.current_page == source.last_page ? 'disabled' : '']">
                <a class="arrow-link" href="#" @click="nextPrev($event, source.current_page+1)">
                    <i class="icon-angle-right"></i>
                </a>
            </page-item>
        </ul>
    </c-pagination>
</template>

<script>
import { CPagination, CPaginationItem, CTotalPagination } from './Styles/Template/styled';

export default {
    name: "Pagination",
    props: {
        source: {
            required: true
        },
        pagination_range: {
            type: Number,
            default: 6
        }
    },
    components: {
        'c-pagination': CPagination,
        'page-item': CPaginationItem,
        'total-pagination': CTotalPagination,
    },
    data() {
        return {
            pages: [],
        }
    },
    methods: {
        navigate(event, page) {
            event.preventDefault();
            this.$emit('navigate', page)
        },
        generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
            var pages = [];
            var totalPages = Math.ceil(collectionLength / rowsPerPage);
            var halfWay = Math.ceil(paginationRange / 2);
            var position;

            if (currentPage <= halfWay) {
                position = 'start';
            } else if (totalPages - halfWay < currentPage) {
                position = 'end';
            } else {
                position = 'middle';
            }

            var ellipsesNeeded = paginationRange < totalPages;
            var i = 1;
            while (i <= totalPages && i <= paginationRange) {
                var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                    pages.push('...');
                } else {
                    pages.push(pageNumber);
                }
                i ++;
            }
            return pages;
        },
        calculatePageNumber(i, currentPage, paginationRange, totalPages) {
            var halfWay = Math.ceil(paginationRange/2);
            if (i === paginationRange) {
                return totalPages;
            } else if (i === 1) {
                return i;
            } else if (paginationRange < totalPages) {
                if (totalPages - halfWay < currentPage) {
                return totalPages - paginationRange + i;
            } else if (halfWay < currentPage) {
                return currentPage - halfWay + i;
            } else {
                return i;
            }
            } else {
                return i;
            }
        },
        nextPrev(event, page) {
            if(page == 0 || page == this.source.last_page+1) {
                return;
            }
            this.navigate(event, page)
        }
    },
    watch: {
        source() {
            let s = this.source
            this.pages = this.generatePagesArray( s.current_page, s.total, s.per_page, this.pagination_range)
        }
    }
};
</script>
